export const SECTION_LOCALE_ZHCHT = {
    expandLabel: 'å±é',
    collapseLabel: 'æ¶èµ·'
};
